import styled from 'styled-components';

export const CommentsWrapper = styled.div`
    position: absolute;
    display: inline-block;
    right: 11px;    
    z-index: 4;
`;

export const CommentsButton = styled.button`
    margin-left: 8px;
    padding: 2px 6px;
    border: 1px solid transparent;
`;

export const CommentsContainer = styled.div`
    position: fixed;
    z-index: 1000;
    background-color: white;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    min-width: 200px;
    max-width: 400px;
    font-size: 0.9em;
    color: #666;
`;
